import { EndpointMode, EndpointType } from '@/api/out';

export interface DatasetRouterParams {
  mode: EndpointMode;
  type: EndpointType;
  resourceId: string;
}

export enum ErrorKey {
  GENERIC = 'generic',
  CONFIG_LOADING = 'config_loading',
  DATASET_DOES_NOT_EXIST = 'dataset_does_not_exist',
  DATASET_LOADING = 'dataset_loading',
  UNKNOWN_PATH = 'unknown_path',
  VISUALIZATION_ERROR = 'visualization_error',
}
